export default {"src":"/_next/static/media/lock-logo.952830cd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};